export default () => {
    var u = navigator.userAgent;
    return {
        ie: u.indexOf('Trident') > -1, //IE内核
        opera: u.indexOf('Presto') > -1, //opera内核
        chrome: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        firefox: u.indexOf('Firefox') > -1, //火狐内核Gecko
    }
}


// WEBPACK FOOTER //
// ./src/tool/getBrowser.js